import React from 'react'

import { Form, Col, Row, Button } from '_zari/core'

import { ModalidadCalculoIsla } from 'constants/index'

import { RounderUtil } from 'utils'

const TIPO_INPUT_PRECIO = {
  SELECT: 'SELECT',
  ITEXT: 'ITEXT'
}

const OpcionCombustible = ({
  arrCombustibles,
  combustibleSeleccionado,
  setCombustibleSeleccionado,
  ladoSeleccionado,
  infoCombustiblexIsla,
  modalidadCalculo,
  datosCombustibleEnUso,
  setDatosCombustibleEnUso,
  setFieldValue,
  handleSubmit,
  flagEdicion
}) => {
  const [indexPrecioSeleccionado, setIndexPrecioSeleccionado] = React.useState(0)
  const [tipoInput, setTipoInput] = React.useState(flagEdicion ? TIPO_INPUT_PRECIO.ITEXT : TIPO_INPUT_PRECIO.SELECT)

  const checked = React.useMemo(() => {
    if (ladoSeleccionado !== infoCombustiblexIsla.lado) {
      return false
    }

    if (combustibleSeleccionado !== infoCombustiblexIsla.combustible) {
      return false
    }

    return true
  }, [combustibleSeleccionado, ladoSeleccionado, infoCombustiblexIsla])

  const onChange = React.useCallback(
    e => {
      const nuevoValor = e.target.value

      const precio = infoCombustiblexIsla.preciosDisponibles[indexPrecioSeleccionado].precio
      let cantidad = 0
      let total = 0

      if (modalidadCalculo === ModalidadCalculoIsla.MONTO_TOTAL) {
        total = nuevoValor
        cantidad = RounderUtil.round(parseFloat(nuevoValor || '0') / precio, 4)
      } else if (modalidadCalculo === ModalidadCalculoIsla.GALONES) {
        cantidad = nuevoValor
        total = RounderUtil.round(parseFloat(nuevoValor || '0') * precio, 4)
      }

      setDatosCombustibleEnUso({
        _idProducto: infoCombustiblexIsla._idProducto,
        _idProductoPresentacion: infoCombustiblexIsla._idProductoPresentacion,
        precio: precio,
        cantidad: cantidad,
        total: total
      })
    },
    [modalidadCalculo, setDatosCombustibleEnUso, infoCombustiblexIsla, indexPrecioSeleccionado]
  )

  const onChangeSelect = React.useCallback(
    e => {
      const nuevoIndex = e.target.value

      setIndexPrecioSeleccionado(nuevoIndex)
      const precio = infoCombustiblexIsla.preciosDisponibles[nuevoIndex].precio

      setDatosCombustibleEnUso(prev => {
        let cantidad = prev.cantidad
        let total = prev.total

        if (modalidadCalculo === ModalidadCalculoIsla.MONTO_TOTAL) {
          cantidad = RounderUtil.round(parseFloat(total || '0') / precio, 4)
        } else if (modalidadCalculo === ModalidadCalculoIsla.GALONES) {
          total = RounderUtil.round(parseFloat(cantidad || '0') * precio, 4)
        }

        return {
          ...prev,
          precio: precio,
          cantidad: cantidad,
          total: total
        }
      })
    },
    [modalidadCalculo, setDatosCombustibleEnUso, infoCombustiblexIsla]
  )

  const onChangeTextPrecio = React.useCallback(
    e => {
      const nuevoPrecio = e.target.value

      setDatosCombustibleEnUso(prev => {
        let cantidad = prev.cantidad
        let total = prev.total

        if (modalidadCalculo === ModalidadCalculoIsla.MONTO_TOTAL) {
          cantidad = RounderUtil.round(nuevoPrecio ? parseFloat(total || '0') / nuevoPrecio : 0, 4)
        } else if (modalidadCalculo === ModalidadCalculoIsla.GALONES) {
          total = RounderUtil.round(parseFloat(cantidad || '0') * nuevoPrecio || 0, 4)
        }

        return {
          ...prev,
          precio: nuevoPrecio,
          cantidad: cantidad,
          total: total
        }
      })
    },
    [modalidadCalculo, setDatosCombustibleEnUso]
  )

  const onChangeRadio = React.useCallback(
    e => {
      setCombustibleSeleccionado(e.target.value)
      setFieldValue('ladoIsla', infoCombustiblexIsla.lado)
      setDatosCombustibleEnUso({})
    },
    [setCombustibleSeleccionado, setDatosCombustibleEnUso, infoCombustiblexIsla, setFieldValue]
  )

  const clickCambiarTipoInput = React.useCallback(
    nuevoTipoInput => {
      if (nuevoTipoInput === TIPO_INPUT_PRECIO.SELECT) {
        setIndexPrecioSeleccionado(0)
        const precio = infoCombustiblexIsla.preciosDisponibles[0].precio

        setDatosCombustibleEnUso(prev => {
          let cantidad = prev.cantidad
          let total = prev.total

          if (modalidadCalculo === ModalidadCalculoIsla.MONTO_TOTAL) {
            cantidad = RounderUtil.round(parseFloat(total || '0') / precio, 4)
          } else if (modalidadCalculo === ModalidadCalculoIsla.GALONES) {
            total = RounderUtil.round(parseFloat(cantidad || '0') * precio, 4)
          }

          return {
            ...prev,
            precio: precio,
            cantidad: cantidad,
            total: total
          }
        })
      }

      setTipoInput(nuevoTipoInput)
    },
    [infoCombustiblexIsla, setDatosCombustibleEnUso, modalidadCalculo]
  )

  const onKeyUpPrecio = e => {
    const keyCode = e.keyCode

    if (keyCode === 13) {
      handleSubmit()
    }
  }

  const onKeyDownPrecio = e => {
    const keyCode = e.keyCode
    if (keyCode === 13) {
      e.preventDefault()
    }
  }

  return (
    <Form.Group>
      <Col md={7}>
        <Row>
          <Col md={12}>
            <Form.Radio
              id={`radio-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
              name='radio-combustibleseleccionado'
              label={`${arrCombustibles.find(x => x.codigo === infoCombustiblexIsla.combustible).nombre}`}
              checked={checked}
              value={infoCombustiblexIsla.combustible}
              onChange={onChangeRadio}
            />
          </Col>
        </Row>
        {checked && (
          <Row>
            <Col md={12}>
              {tipoInput === TIPO_INPUT_PRECIO.SELECT ? (
                <Form.InputGroup>
                  <Form.Select
                    id={`select-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
                    name={`select-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
                    onChange={onChangeSelect}
                    value={indexPrecioSeleccionado}
                  >
                    {infoCombustiblexIsla?.preciosDisponibles.map((y, k) => (
                      <option key={k} value={k}>
                        {y.precio}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.InputGroup.Append>
                    <Button outline onClick={() => clickCambiarTipoInput(TIPO_INPUT_PRECIO.ITEXT)}>
                      o
                    </Button>
                  </Form.InputGroup.Append>
                </Form.InputGroup>
              ) : (
                <Form.InputGroup>
                  <Form.InputNumber
                    autoFocus={true}
                    id={`inputNumer-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
                    name={`inputNumer-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
                    onChange={onChangeTextPrecio}
                    value={datosCombustibleEnUso.precio}
                  />
                  <Form.InputGroup.Append>
                    <Button outline onClick={() => clickCambiarTipoInput(TIPO_INPUT_PRECIO.SELECT)}>
                      o
                    </Button>
                  </Form.InputGroup.Append>
                </Form.InputGroup>
              )}
            </Col>
          </Row>
        )}
      </Col>
      {checked && (
        <Col md={5}>
          <Form.InputNumber
            autoFocus={true}
            id={`input-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
            name={`input-${infoCombustiblexIsla.lado}-${infoCombustiblexIsla.combustible}`}
            onChange={onChange}
            value={modalidadCalculo === ModalidadCalculoIsla.MONTO_TOTAL ? datosCombustibleEnUso.total : datosCombustibleEnUso.cantidad}
            onKeyDown={onKeyDownPrecio}
            onKeyUp={onKeyUpPrecio}
          />
        </Col>
      )}
    </Form.Group>
  )
}

export default React.memo(OpcionCombustible)
